;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('coreFilterBy', coreFilterBy)

  /* @ngInject */
  function coreFilterBy () {
    return {
      restrict: 'E',
      scope: {
        params: '=',
        filters: '<'
      },
      templateUrl: '/core/directives/core-filters/filters/core-filter-by/core-filter-by-directive.html?$$REVISION$$',
      controller: 'CoreFilterByController'
    }
  }
})()
